import { BRAND, NAV } from "@/lib/site";
import { Logo } from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#17101a] text-white py-16 md:py-20" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <Logo className="h-10" />
            <p className="mt-6 max-w-sm text-white/60 leading-relaxed text-sm">
              {BRAND.blurb}
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                {n.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {BRAND.name} · {BRAND.domain}</p>
          <p>Made in Canada · coast to coast to coast.</p>
        </div>
      </div>
    </footer>
  );
}
